module.exports = __webpack_public_path__ + "img/axis-realty-group-banner-1.695effab.jpg";